<template>
    <div class="flex w-full justify-center items-center h-screen">
        <div class="container w-96 bg-[#f8f4f3] p-8 rounded-md shadow-md">

            <a href="#" class="flex items-center pb-4 border-b border-b-gray-800 mb-4">
                <!-- Title -->
                <h2 class="font-bold text-2xl">AI <span class="bg-[#f84525] text-white px-2 rounded-md">CODE</span></h2>
            </a>
            <div class="text-center">
                <p class="text-base font-semibold text-gray-600">Network error or server not responding!</p>
                <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">ERROR</h1>
                <div class="mt-10 flex items-center justify-center gap-x-6">
                    <a href="/login"
                        class="w-full bg-gray-800 text-white font-bold py-2 px-4 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50">
                        back home</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ErrorPage'
});
</script>

<style scoped>
h1 {
    color: red;
}
</style>